import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { auth } from '../firebase';
import { signInWithEmailAndPassword, signOut } from 'firebase/auth';
import { useAuthState } from 'react-firebase-hooks/auth';
import { LoadingButton } from '@mui/lab';
import { useNavigate } from 'react-router-dom';

export default function LoginDialog({buttonHidden, isOpen, redirect} = {buttonHidden: false, isOpen: false, redirect: null}) {
  const [user, authLoading, error] = useAuthState(auth);
  const [open, setOpen] = React.useState(isOpen);
  const navigate = useNavigate();

    const [creds, setCreds] = React.useState({
        email: '',
        password: ''
    });

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleLogin = async () => {
    try {
        const res = await signInWithEmailAndPassword(auth, creds.email, creds.password);
        handleClose();
        if(redirect) 
          navigate(redirect)
        console.log(res)
    } catch (err) {
        console.error(err);
        alert(err.message);
    }
  }

  const handleLogout = async () => {
    await signOut(auth)
  }

  return (
      <>
      {/* Hidden on login page */}
      {!buttonHidden && (
        !user ? 
          <Button color="inherit" variant="outlined" onClick={handleClickOpen}>Login</Button> :
          <Button color="inherit" variant="outlined" onClick={handleLogout}>Logout</Button>
        )
      }
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Admin Login</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            id="name"
            label="Email Address"
            type="email"
            onChange={(e) => setCreds({...creds, email: e.target.value})}
            fullWidth
            variant="standard"
          />
        <TextField
            autoFocus
            margin="dense"
            id="password"
            label="Password"
            onChange={(e) => setCreds({...creds, password: e.target.value})}
            type="password"
            fullWidth
            variant="standard"
          />
        </DialogContent>
        <DialogActions>
          <LoadingButton onClick={handleLogin} loading={authLoading}>Login</LoadingButton>
        </DialogActions>
      </Dialog>
      </>
  );
}